document.addEventListener("DOMContentLoaded", () => {
    const hash = decodeURI(window.location.hash.substring(1));
    const container = document.querySelector('.accordion-or-tabs__accordion-content');

  
    // If we have a hash and it's a valid value
    if (hash && container && container.querySelector(`.accordion-item[data-name*="${hash}"]`)) {
        // clear all
        const accordionItems = container.querySelectorAll('.accordion-item');
        accordionItems.forEach((item) => {
            item.querySelector('.accordion-button').classList.add('collapsed');
            item.querySelector('.accordion-button').setAttribute('aria-expanded', 'false');
            item.querySelector('.accordion-collapse').classList.remove('show');
        });

        // mark the targeted one
        const selectedAccordionItem = container.querySelector(`.accordion-item[data-name*="${hash}"]`);
        selectedAccordionItem.querySelector('.accordion-button').classList.remove('collapsed');
        selectedAccordionItem.querySelector('.accordion-button').setAttribute('aria-expanded', 'true');
        selectedAccordionItem.querySelector('.accordion-collapse').classList.add('show');


   // clear all tabs
        const tabNavLinks = container.querySelectorAll('.accordion-or-tabs__accordion-tabs > ul > li > .nav-link');
        tabNavLinks.forEach((item) => {
            item.classList.remove('active');
        });
        const tabPanes = container.querySelectorAll('.tab-pane');
        tabPanes.forEach((item) => {
            item.classList.remove('active');
            item.setAttribute('aria-hidden', 'true');
        });

        // activate the targeted tab
        const accordionOrTabs = container.querySelector(`.accordion-or-tabs__accordion-tabs > ul > li[data-name*="${hash}"] > .nav-link`);
        accordionOrTabs.classList.add('active');

        const tabPane = container.querySelector(`.tab-pane[data-name*="${hash}"]`);
        tabPane.classList.add('active');
        tabPane.removeAttribute('aria-hidden');
    }

    // Listen for tab shown event to update aria-hidden attributes
    const tabLinks = document.querySelectorAll('.accordion-or-tabs__accordion-tabs .nav-link');
    tabLinks.forEach((tabLink) => {
        tabLink.addEventListener('shown.bs.tab', (event) => {
            const target = event.target; // newly activated tab
            const previous = event.relatedTarget; // previous active tab

            // Update aria-hidden attributes for content panes
            if (previous) {
                const previousPaneId = previous.getAttribute('aria-controls');
                const previousPane = document.getElementById(previousPaneId);
                previousPane.setAttribute('aria-hidden', 'true');
            }

            const targetPaneId = target.getAttribute('aria-controls');
            const targetPane = document.getElementById(targetPaneId);
            targetPane.removeAttribute('aria-hidden');
        });
    });
});

